module.exports = __webpack_public_path__ + "img/loading.0325ac63.png";